import Store from '../Store';
import RestClient from 'shared/Network/RestClient';
import { toast } from 'react-toastify';
import { observable, action } from 'mobx';

class ItemStoreClass extends Store {
   
    fetchData() {
        return new Promise(async (resolve, reject) => {
            if (this.status.fetched) {
                return resolve(this.list);
            }

            try {
                this.status.loading = true;

                const skus = await this.fetchRoute('accountsoverview/listings/skus');

                this.status.fetched = true;

                this.list = skus;

                this.status.loading = false;
                resolve(this.list);
            } catch (error) {
                this.status.error = error.error?.message || error.data?.error || error.error || error.message || JSON.stringify(error) || 'An error occurred';
                this.status.loading = false;
                reject(error);
            }
        });
    }

    async fetchRoute(route = '') {
        const request = RestClient.prepareRequest('GET', route);

        try {
            const res = await request.send();

            if (res.success && 'data' in res) {
                return res.data?.value || res.data;
            } else {
                throw res.error?.message || res.data?.error || res.error || res.message || JSON.stringify(res) || 'An error occurred';
            }
        } catch (error) {
            toast.error(`Error fetching "${route}": ${error}`);
            return [];
        }
    }
}

const ItemStore = new ItemStoreClass('accountsoverview/listings/skus');

export default ItemStore;